(() => {
  function init(scope = document) {
    scope.querySelectorAll('.shopde-feature-stage').forEach(stage => {
      if (stage._homeLayout) return;
      const hero = stage.querySelector('.shopde-feature-hero');
      const rail = stage.querySelector('.shopde-feature-carousel--large [data-home-rail]');
      if (!hero || !rail) return;
      const origin = document.createComment('Roborock desktop position');
      hero.before(origin);
      const mobile = matchMedia('(max-width: 989px)');
      const layout = () => {
        if (mobile.matches) rail.prepend(hero);
        else origin.after(hero);
        rail.scrollTo({ left: 0, behavior: 'instant' });
      };
      mobile.addEventListener('change', layout);
      stage._homeLayout = () => mobile.removeEventListener('change', layout);
      layout();
    });
    scope.querySelectorAll('[data-home-carousel]').forEach(carousel => {
      if (carousel.dataset.initialized) return;
      carousel.dataset.initialized = 'true';
      const rail = carousel.querySelector('[data-home-rail]');
      const prev = carousel.querySelector('[data-home-prev]');
      const next = carousel.querySelector('[data-home-next]');
      let dots;
      if (carousel.classList.contains('shopde-feature-carousel--large')) {
        dots = document.createElement('div');
        dots.className = 'shopde-feature-dots';
        dots.setAttribute('aria-hidden', 'true');
        rail.after(dots);
      }
      const update = () => {
        prev.disabled = rail.scrollLeft <= 2;
        next.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
        prev.hidden = prev.disabled;
        next.hidden = next.disabled;
        if (dots) {
          if (dots.children.length !== rail.children.length) dots.replaceChildren(...[...rail.children].map(() => document.createElement('span')));
          const current = Math.round(rail.scrollLeft / (rail.clientWidth + parseFloat(getComputedStyle(rail).columnGap)));
          [...dots.children].forEach((dot, index) => dot.classList.toggle('is-active', index === current));
        }
      };
      const step = direction => {
        const cards = [...rail.children];
        const current = cards.reduce((best, card, index) => Math.abs(card.offsetLeft - rail.offsetLeft - rail.scrollLeft) < Math.abs(cards[best].offsetLeft - rail.offsetLeft - rail.scrollLeft) ? index : best, 0);
        const single = carousel.classList.contains('shopde-feature-carousel--large') && matchMedia('(max-width: 989px)').matches;
        if (single) {
          const target = cards[Math.max(0, Math.min(cards.length - 1, current + direction))];
          rail.scrollTo({ left: target.offsetLeft - rail.offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        } else rail.scrollBy({ left: direction * rail.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      prev.addEventListener('click', () => step(-1));
      next.addEventListener('click', () => step(1));
      rail.addEventListener('scroll', update, { passive: true });
      rail.addEventListener('keydown', event => {
        if (event.target !== rail || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault(); step(event.key === 'ArrowRight' ? 1 : -1);
      });
      const resize = new ResizeObserver(update); resize.observe(rail);
      carousel._homeResize = resize;
      update();
    });
  }
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-home-carousel]').forEach(el => el._homeResize?.disconnect());
    event.target.querySelectorAll('.shopde-feature-stage').forEach(el => el._homeLayout?.());
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
})();
